import RouteTemplate from 'ember-route-template'
import { t } from 'ember-intl'
import { ReportingControls } from 'teacher-ui-client/components/reporting/controls'
import { ReportingControlsGap } from 'teacher-ui-client/components/reporting/controls-gap'
import { ReportingUiScopeSelect } from 'teacher-ui-client/components/reporting/ui-scope-select'
import { ReportingPeriodSelect } from 'teacher-ui-client/components/reporting/period-select'
import { ReportingExportSelect, ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import type WritingLegendsQuizzesCompletedController from 'teacher-ui-client/reporting/ui-scope/writing-legends/quizzes-completed/controller'
import type WritingLegendsQuizzesCompletedRoute from 'teacher-ui-client/reporting/ui-scope/writing-legends/quizzes-completed/route'
import { ReportLoader as AveragesReportLoader } from 'teacher-ui-client/components/reporting/writing-legends/quizzes-completed/averages/report-loader'
import { ReportLoader as HistoryReportLoader } from 'teacher-ui-client/components/reporting/writing-legends/quizzes-completed/history/report-loader'
import { array } from '@ember/helper'
import { hash } from '@ember/helper'
import type { TOC } from '@ember/component/template-only'

interface Signature {
  Args: {
    model: ModelFor<WritingLegendsQuizzesCompletedRoute>
    controller: WritingLegendsQuizzesCompletedController
  }
}

export const WritingLegendsQuizzesCompletedPage: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.quizzesCompleted"}} />
  <ReportingControls>
    <ReportingUiScopeSelect class="shrink basis-80" />
    <ReportingControlsGap />
    <ReportingPeriodSelect />
    <ReportingControlsGap />
    <ReportingExportSelect @exportOptions={{array (hash exportType=ExportType.print)}} />
  </ReportingControls>
  <div class="space-y-4">
    <AveragesReportLoader @uiScope={{@model.uiScope}} @period={{@model.period}} />
    <HistoryReportLoader
      @uiScope={{@model.uiScope}}
      @period={{@model.period}}
      @sort={{@controller.sort}}
      @pageNumber={{@controller.pageNumber}}
      @perPage={{@controller.perPage}}
    />
  </div>
</template>

export default RouteTemplate(WritingLegendsQuizzesCompletedPage)
